import { validateProps } from '../utils';
export const isValidLinkedAccount = properties => {
  const ans = validateProps(properties, ['id', 'provider', 'tokenId', 'email']);
  return ans;
};
//# sourceMappingURL=LinkedAccount.js.map